import { InputValidation, Label } from "@components";
import DatePicker from "@components/forms/DatePicker";
import PricingRecord, { PricingSettings } from "@models/PricingRecord";
import {
	isAfter,
	isBefore,
	isFirstDayOfMonth,
	isLastDayOfMonth,
} from "date-fns";
import React from "react";
import { FormGroup } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";
import FlatFeePerEmployeeSettings from "./FlatFeePerEmployeeSettings";
import FlatFeePerEmployeePackSettings from "./FlatFeePerEmployeePackSettings";
import FlatFeePerModuleAndEmployeeSettings from "./FlatFeePerModuleAndEmployeeSettings";
import FlatFeeSettings from "./FlatFeeSettings";
import { PricingCardProps } from "./IPricingCardProps";
import YearlyBillingSettings from "./YearlyBillingSettings";
import MinimumFeeSetting from "./MinimumFeeSetting";

export default function PricingRecordContent(
	props: PricingCardProps & { dateOverlapError?: { message: string } }
) {
	const { pricingSettings, index, dateOverlapError } = props;
	const { setValue, control } =
		useFormContext<{ pricingSettings: PricingSettings | null }>();
	const pricingRecord: PricingRecord = pricingSettings[index];

	return (
		<Container>
			<FormGroup key={"availableFromUntil"}>
				<InputValidation error={dateOverlapError}>
					<span>
						<Label htmlFor={"availableFrom"}>Gültig von</Label>{" "}
						<Controller
							control={control}
							name={`pricingSettings.${index}.availableFrom`}
							defaultValue={pricingRecord?.availableFrom || null}
							rules={{
								validate: () => !dateOverlapError,
							}}
							render={({ field }) => (
								<DatePicker
									{...field}
									isDayDisabled={(day) =>
										(!!pricingRecord.availableUntil &&
											isAfter(day, pricingRecord.availableUntil)) ||
										!isFirstDayOfMonth(day)
									}
									ref={field.ref}
									placeholder="unbefristet"
									canClearDate
									onClearDate={() =>
										setValue(`pricingSettings.${index}.availableFrom`, null, {
											shouldDirty: true,
										})
									}
								/>
							)}
						/>{" "}
						<Label htmlFor={"availableUntil"}>bis</Label>{" "}
						<Controller
							control={control}
							name={`pricingSettings.${index}.availableUntil`}
							defaultValue={pricingRecord?.availableUntil || null}
							rules={{
								validate: () => !dateOverlapError,
							}}
							render={({ field }) => (
								<DatePicker
									isDayDisabled={(day) =>
										(!!pricingRecord.availableFrom &&
											isBefore(day, pricingRecord.availableFrom)) ||
										!isLastDayOfMonth(day)
									}
									{...field}
									ref={field.ref}
									canClearDate
									placeholder="unbefristet"
									onClearDate={() =>
										setValue(`pricingSettings.${index}.availableUntil`, null, {
											shouldDirty: true,
										})
									}
								/>
							)}
						/>
					</span>
				</InputValidation>
			</FormGroup>
			<YearlyBillingSettings {...props} />
			<MinimumFeeSetting {...props} />
			<FlatFeePerEmployeeSettings {...props} />
			<FlatFeePerEmployeePackSettings {...props} />
			<FlatFeePerModuleAndEmployeeSettings {...props} />
			<FlatFeeSettings {...props} />
		</Container>
	);
}

const Container = styled.div`
	padding: 2rem;
`;
